<div *ngIf="config" class="template-container">
    <div [ngSwitch]="config.componentType" class="template-container">
        <div *ngSwitchCase="'Notes'" class="template-container">
            <tam-contact-note [config]="config"></tam-contact-note>
        </div>
        <div *ngSwitchCase="'Activities'" class="template-container">
            <tam-contact-panel-activity [config]="config" #panel></tam-contact-panel-activity>
        </div>
        <div *ngSwitchCase="'Relationships'" class="template-container">
            <tam-contact-relationship [config]="config"></tam-contact-relationship>
        </div>
        <!-- below is the basic information -->
        <div *ngSwitchCase="'Address'" class="template-container">
            <tam-contact-information [config]="config"></tam-contact-information>
        </div>
        <div *ngSwitchCase="'Basic Information'" class="template-container">
            <tam-contact-information [config]="config"></tam-contact-information>
        </div>
        <div *ngSwitchCase="'Contact Information'" class="template-container">
            <tam-contact-information [config]="config"></tam-contact-information>
        </div>
        <div *ngSwitchCase="'Internet'" class="template-container">
            <tam-contact-information [config]="config"></tam-contact-information>
        </div>
        <div *ngSwitchCase="'Others'" class="template-container">
            <tam-contact-information [config]="config"></tam-contact-information>
        </div>
        <div *ngSwitchCase="'Employment'" class="template-container">
            <tam-contact-information [config]="config"></tam-contact-information>
        </div>
    </div>
</div>